import PropTypes from 'prop-types'

import { OrderTypes } from '../../models/orders/order-types-enum.js'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { orderMessageLocationPropType } from './order-message-location-prop-type'

/**
 * @typedef {Object} Order
 * @property {string} [orderState] - order status, e.g. sent
 * @property {Id} [orderMessageId] - id of assigned vehicle
 * @property {Object} [message] - message info
 * @property {OrderMessageLocation} [location] - location data for the message
 * @property {ISO8601} [messageTime] - time the message was sent
 */

export const orderMessagePropType = PropTypes.shape({
    location: orderMessageLocationPropType,
    message: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    messageTime: iso8601PropType,
    orderMessageId: idPropType,
    orderState: PropTypes.oneOf(Object.values(OrderTypes))
})
